import { Dispatch } from 'redux';
import { setUser, toggleAuthModalVisible } from '@/app/lib/redux';
import { AuthActions } from '@mybestbrands/types';
import { trackSSTEvent } from '@/app/utils/tracking';

export const handleFavoriteBrands = (
  user: any,
  isFavoriteBrand: boolean,
  dispatch: Dispatch,
  apiUrl?: string,
  brandId?: string
) => {
  if (!user) {
    dispatch(toggleAuthModalVisible(AuthActions.LOGIN));
    return;
  }

  fetch(`${apiUrl}/user/favoritebrands`, {
    method: isFavoriteBrand ? 'DELETE' : 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: [brandId] }),
  })
    .then((res) => res.text())
    .then(() => {
      const wlData = user?.WatchlistBrands || [];
      const updatedFavoriteBrands = isFavoriteBrand
        ? wlData.filter((r: string) => r !== brandId)
        : [...wlData, brandId];

      dispatch(setUser({ ...user, WatchlistBrands: updatedFavoriteBrands }));
      trackSSTEvent('brand_toggle', { brandId });
    });
};
